import { useAgentProfileListControllerAgentProfileListForUsersQuery } from '@shared/services/apiService';
import { AgentProfileTypeEnum } from '../types';
import { useMemo } from 'react';

export const useAgentProfiles = () => {
  const { data, isLoading, error, refetch } =
    useAgentProfileListControllerAgentProfileListForUsersQuery(
      {
        filter: undefined,
      },
      { refetchOnMountOrArgChange: true },
    );

  const customAgentProfiles = useMemo(
    () => data?.filter((ap) => ap.type === AgentProfileTypeEnum.CUSTOM),
    [data],
  );
  const systemAgentProfiles = useMemo(
    () => data?.filter((ap) => ap.type === AgentProfileTypeEnum.SYSTEM),
    [data],
  );
  const customerTemplateAgentProfiles = useMemo(
    () => data?.filter((ap) => ap.type === AgentProfileTypeEnum['CUSTOMER-TEMPLATE']),
    [data],
  );

  return {
    data,
    customAgentProfiles,
    systemAgentProfiles,
    customerTemplateAgentProfiles,
    isLoading,
    error,
    refetch,
  };
};
